import { Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import OrdersApi from "../../api/OrdersApi";
import { AppContext } from "../../AppContext";
import { memberState } from "../../state/atoms";
import "./PrintCheckoutPage.scss";
import { Cart } from "./views/Cart";
import { EmptyCart } from "./views/EmptyCart";
import { Payment } from "./views/Payment";
import { Shipping } from "./views/Shipping";
import { Success } from "./views/Success";
import { logViewCart } from "../../service/AnalyticsService";

export function PrintCheckoutPage({ path, setCartCount }: any) {
  const [loading, setLoading] = useState(false);
  const [isComputingTax, setIsComputingTax] = useState(false);
  const [view, setView] = useState(path || 'cart');

  const { location } = useContext(AppContext);
  const [member] = useRecoilState(memberState);
  const [order, setOrder] = useState() as any;

  const [checkoutMessage, setCheckoutMessage] = useState("");

  useEffect(() => {
    // get order
    if (!order) {
      setLoading(true);

      OrdersApi.getDraftOrder(location.internalId!).then((resp) => {
        if (!resp.data) {
          setView("empty");
        } else {
          resp.data.items = resp.data.items?.reverse();
          setOrder(resp.data);

          logViewCart(resp.data);
        }
        // setView("success");

        setLoading(false);
      });

      OrdersApi.getCheckoutMessage().then((resp) => {
        setCheckoutMessage(resp.data)
      });
    }
  }, [order, member.internalId, location.internalId]);

  return (
    <div className={"print-checkout-page content"}>
      {loading && <Skeleton />}

      {!loading && view === "empty" && (
        <EmptyCart view={view} setView={setView} />
      )}

      {!loading && order && view === "cart" && (
        <Cart order={order} setOrder={setOrder} view={view} setView={setView} setCartCount={setCartCount} />
      )}

      {!loading && order && view === "shipping" && (
        <Shipping order={order} setOrder={setOrder} view={view} setView={setView} 
          isComputingTax={isComputingTax} setIsComputingTax={setIsComputingTax} checkoutMessage={checkoutMessage} />
      )}

      {!loading && order && view === "payment" && (
        <Payment order={order} setOrder={setOrder} view={view} setView={setView} setCartCount={setCartCount} checkoutMessage={checkoutMessage} />
      )}
      {!loading && order && view === "success" && (
        <Success order={order} view={view} setView={setView} />
      )}
    </div>
  );
}
